// src/i18n/translations.js

export const translations = {
  ru: {
    nav: {
      home: "Главная",
      case: "Кейс",
      roadmap: "Развитие",
      docs: "Документация",
      resources: "Публикации",
      pricing: "Тарифы",
      requestDemo: "Запросить демо",
      menu: "Меню"
    },
    theme: {
      light: "Светлая тема",
      dark: "Тёмная тема"
    },
    loading: "Загрузка...",
    hero: {
      title: "Система мониторинга<br />терминальной сети",
      subtitle: "Профессиональное решение для контроля банкоматов, платёжных терминалов, POS-устройств и IoT-инфраструктуры. Снижение OPEX на 45%, ROI 340%.",
      requestDemo: "Запросить демонстрацию",
      learnMore: "Подробнее"
    },
    stats: {
      roi: "Средний ROI за первый год",
      opex: "Снижение затрат на обслуживание",
      payback: "Срок окупаемости внедрения"
    },
    features: {
      title: "Ключевые возможности",
      subtitle: "Комплексная система мониторинга для обеспечения бесперебойной работы терминальной инфраструктуры",
      operationalControl: "Оперативный контроль",
      operationalControlDesc: "Мониторинг статуса, загрузки CPU, памяти, температуры и сети в реальном времени. Все устройства — в единой панели управления.",
      preventDowntime: "Предотвращение простоев",
      preventDowntimeDesc: "Раннее выявление сбоев и автоматические уведомления. Снижение времени реакции с 15 минут до 45 секунд.",
      softwareManagement: "Управление ПО",
      softwareManagementDesc: "Централизованное обновление, удалённая диагностика и контроль версий на всех устройствах сети.",
      security: "Безопасность",
      securityDesc: "Обнаружение атак, контроль целостности данных, шифрование SHA-256 и блокировка скомпрометированных устройств.",
      aiAnalytics: "AI-аналитика",
      aiAnalyticsDesc: "Предиктивная аналитика на основе машинного обучения. Прогноз сбоев за 24-48 часов до их возникновения.",
      cashAnalytics: "Кассовая аналитика",
      cashAnalyticsDesc: "Прогнозирование кассовых разрывов, оптимизация пополнения и прогнозирование потребности в наличных на 30 дней."
    },
    businessBenefits: {
      title: "Выгоды для бизнеса",
      subtitle: "Измеримый экономический эффект от внедрения системы мониторинга",
      costReduction: "Снижение затрат",
      costReductionDesc: "Проактивный мониторинг сокращает затраты на обслуживание на 45%. Автоматизация рутинных операций уменьшает потребность в выездном персонале на 88%.",
      availability: "Повышение доступности",
      availabilityDesc: "Время простоя терминалов снижается с 6.2% до 0.8%. Количество инцидентов в месяц падает с 32 до 6. Клиенты получают бесперебойный сервис.",
      fastResponse: "Быстрое реагирование",
      fastResponseDesc: "Автоматические уведомления и сценарии реагирования. Среднее время реакции на инцидент — 45 секунд вместо 15 минут.",
      transparency: "Прозрачность и отчётность",
      transparencyDesc: "Полная статистика по загрузке, отчёты для руководства, данные для стратегического планирования и масштабирования."
    },
    techStack: {
      title: "Технологический стек",
      subtitle: "Современная архитектура, обеспечивающая надёжность и производительность",
      backend: "Backend",
      backendDesc: "Node.js (Express, Sequelize), PostgreSQL для хранения данных, Redis для кэширования и очередей, RabbitMQ для обмена сообщениями.",
      frontend: "Frontend",
      frontendDesc: "React + Vite для быстрой панели управления. Bootstrap 5 для адаптивного интерфейса. Тёмная и светлая темы.",
      api: "API и протоколы",
      apiDesc: "REST API со Swagger-документацией. gRPC и Protocol Buffers для общения устройств с сервером — высокая производительность и строгая типизация.",
      agent: "Агент",
      agentDesc: "Кроссплатформенный агент на Node.js для Windows и Linux. Работа через NAT, очередь команд при потере связи, авто-восстановление."
    },
    dashboard: {
      title: "Панель управления",
      subtitle: "Интерфейс системы мониторинга для инженеров поддержки"
    },
    systemComponents: {
      title: "Компоненты системы",
      subtitle: "Внутренние механизмы мониторинга, логирования и управления задачами",
      terminalEvents: "События терминала",
      terminalEventsDesc: "Логирование всех событий: подключение/отключение, изменение статуса, команды управления в реальном времени.",
      clientLog: "Лог клиента",
      clientLogDesc: "Детальные логи работы агента на устройстве: диагностика, ошибки, состояние подключения к серверу.",
      serverLog: "Лог сервера",
      serverLogDesc: "Серверные логи обработки команд, WebSocket-соединений, взаимодействия с PostgreSQL и RabbitMQ.",
      rabbitMq: "Очередь задач RabbitMQ",
      rabbitMqDesc: "Управление очередями команд и событий: распределение задач, приоритеты, гарантия доставки."
    },
    deployment: {
      title: "Форматы поставки",
      subtitle: "Выберите подходящий вариант развёртывания под ваши требования",
      onPremise: "On-Premise",
      onPremiseDesc: "Полностью развёртывается в инфраструктуре клиента. Подходит для банков, госучреждений и компаний с высокими требованиями к безопасности.",
      onPremiseFeatures: [
        "Размещение на локальных серверах",
        "Полный контроль над данными",
        "Интеграция с AD, CRM, SIEM",
        "Поддержка аудита"
      ],
      saas: "SaaS (Облако)",
      saasDesc: "Готовое решение в облаке. Быстрый старт без инвестиций в сервера.",
      saasFeatures: [
        "Развёртывание за несколько часов",
        "Автоматические обновления",
        "Гибкая подписка",
        "Доступ из любой точки"
      ]
    },
    pricing: {
      title: "Тарифные планы",
      subtitle: "Выберите подходящий план для вашей инфраструктуры",
      order: "Оформить",
      starter: {
        name: "Стартовый",
        description: "Для небольших сетей до 100 устройств",
        price: "45 000",
        period: "/мес",
        features: [
          "До 100 устройств",
          "Базовый мониторинг",
          "Уведомления по email",
          "Поддержка в рабочее время",
          "Обновления ПО"
        ],
        cta: "Начать"
      },
      business: {
        name: "Бизнес",
        description: "Для средних сетей до 1000 устройств",
        price: "150 000",
        period: "/мес",
        popular: "Популярный",
        features: [
          "До 1000 устройств",
          "Полный мониторинг + AI",
          "Уведомления все каналы",
          "Поддержка 24/7",
          "Приоритетные обновления",
          "Кассовая аналитика",
          "API доступ"
        ],
        cta: "Выбрать план"
      },
      enterprise: {
        name: "Корпоративный",
        description: "Для крупных сетей без ограничений",
        price: "Индивидуально",
        period: "",
        features: [
          "Неограниченно устройств",
          "Полный функционал",
          "Выделенный менеджер",
          "SLA 99.99%",
          "Кастомная интеграция",
          "Обучение команды",
          "On-site поддержка"
        ],
        cta: "Связаться"
      }
    },
    cta: {
      title: "Готовы начать?",
      subtitle: "Запросите демонстрацию системы и узнайте, как ТСМ может оптимизировать управление вашей терминальной инфраструктурой",
      button: "Запросить демонстрацию"
    },
    trustBadges: {
      title: "Надёжность и соответствие",
      subtitle: "Официально зарегистрированное ПО, соответствующее требованиям российского рынка",
      items: [
        {
          icon: "📜",
          title: "Свидетельство Роспатента",
          desc: "Программа зарегистрирована в Роспатенте. Официальная защита интеллектуальной собственности."
        },
        {
          icon: "🔒",
          title: "152-ФЗ",
          desc: "Полное соответствие закону о персональных данных. Хранение данных на территории РФ."
        },
        {
          icon: "🏢",
          title: "On-Premise",
          desc: "Развёртывание на ваших серверах. Данные не покидают вашу инфраструктуру."
        },
        {
          icon: "🇷🇺",
          title: "Российская разработка",
          desc: "Полный цикл разработки в России. Включено в реестр отечественного ПО."
        },
        {
          icon: "🛡️",
          title: "Финансовый сектор",
          desc: "Соответствие требованиям ЦБ РФ. Подходит для банков и платёжных организаций."
        },
        {
          icon: "📊",
          title: "1000+ устройств",
          desc: "Система успешно мониторит тысячи терминалов в пилотных внедрениях."
        }
      ]
    },
    roiCalculator: {
      title: "Рассчитайте вашу экономию",
      subtitle: "Узнайте, сколько сэкономит ТСМ при вашей инфраструктуре",
      inputs: {
        label: "Входные данные",
        devices: { label: "Количество устройств", placeholder: "500" },
        visitCost: { label: "Стоимость выезда инженера (₽)", placeholder: "5 000" },
        downtimeCost: { label: "Стоимость простоя 1 устройства в час (₽)", placeholder: "2 000" },
        monthlyIncidents: { label: "Инцидентов в месяц", placeholder: "100" }
      },
      results: {
        annualSavings: "Годовая экономия",
        downtimeReduction: "Снижение простоев",
        roi: "ROI за первый год",
        paybackMonths: "Срок окупаемости",
        perDevice: "Экономия на 1 устройство",
        savings: "₽",
        percent: "%",
        months: "мес",
        devices: "устр."
      },
      note: "Расчёт основан на средних показателях внедрений ТСМ. Фактические результаты могут отличаться."
    },
    comparison: {
      title: "Сравнение с альтернативами",
      subtitle: "Почему ТСМ лучше универсальных систем мониторинга для терминальной инфраструктуры",
      table: {
        headers: ["Критерий", "ТСМ", "Zabbix", "SolarWinds", "Ручной мониторинг"],
        rows: [
          { feature: "Мониторинг терминалов и банкоматов", tcm: "✓ Из коробки", zabbix: "✗ Настройка", solarwinds: "✗ Нет", manual: "✗ Нет" },
          { feature: "Протокол gRPC", tcm: "✓ Высокая скорость", zabbix: "✗ Нет", solarwinds: "✗ Нет", manual: "✗ Нет" },
          { feature: "Работа через NAT", tcm: "✓ Встроена", zabbix: "✗ Настройка", solarwinds: "✗ Нет", manual: "✗ Нет" },
          { feature: "Кассовая аналитика", tcm: "✓ AI-прогноз", zabbix: "✗ Нет", solarwinds: "✗ Нет", manual: "✗ Нет" },
          { feature: "On-Premise", tcm: "✓", zabbix: "✓", solarwinds: "✓", manual: "—" },
          { feature: "152-ФЗ / ЦБ РФ", tcm: "✓", zabbix: "✗", solarwinds: "✗", manual: "—" },
          { feature: "Реестр отечественного ПО", tcm: "✓", zabbix: "✗", solarwinds: "✗", manual: "—" },
          { feature: "Стоимость внедрения", tcm: "Средняя", zabbix: "Низкая*", solarwinds: "Высокая", manual: "Очень высокая" },
          { feature: "*Дополнительные затраты на разработку и поддержку", tcm: "", zabbix: "", solarwinds: "", manual: "" }
        ]
      },
      note: "*Zabbix бесплатен, но требует значительных затрат на настройку и поддержку"
    },
    faq: {
      title: "Частые вопросы",
      subtitle: "Ответы на типичные вопросы о внедрении и работе системы ТСМ",
      items: [
        {
          q: "Сколько времени занимает внедрение ТСМ?",
          a: "Стандартное внедрение для сети до 500 устройств занимает 2-4 недели. Включает установку сервера, подключение устройств, настройку уведомлений и обучение команды. Для крупных сетей — до 8 недель с поэтапным подключением."
        },
        {
          q: "Можно ли развернуть ТСМ на собственных серверах?",
          a: "Да, On-Premise — основной формат поставки. Система разворачивается в вашей инфраструктуре, данные не покидают ваш периметр. Поддерживается развёртывание на Linux-серверах любой конфигурации."
        },
        {
          q: "Соответствует ли система требованиям 152-ФЗ и ЦБ РФ?",
          a: "Да, ТСМ полностью соответствует Федеральному закону №152-ФЗ о персональных данных. Данные хранятся на территории РФ. Решение подходит для банков и платёжных организаций, подпадающих под регуляторные требования ЦБ."
        },
        {
          q: "Можно ли интегрировать ТСМ с нашей SIEM-системой?",
          a: "Да, система предоставляет REST API и поддерживает интеграцию с популярными SIEM-системами (Splunk, ELK Stack, ArcSight). Также возможна интеграция с Active Directory, CRM-системами и системами тикетинга."
        },
        {
          q: "Что если у нас уже стоит Zabbix или другой мониторинг?",
          a: "ТСМ не заменяет, а дополняет универсальные системы. Zabbix мониторит серверы и сеть, а ТСМ — специализированные терминальные устройства (банкоматы, платёжные терминалы, IoT). Интеграция через API позволяет объединить данные в единой панели."
        },
        {
          q: "Какая требуется инфраструктура для работы ТСМ?",
          a: "Минимальная конфигурация: 2 vCPU, 4 ГБ RAM, 50 ГБ SSD для сервера ТСМ. PostgreSQL 14+ и Redis для production-развёртывания. Агент ТСМ работает на любом Linux-устройстве с 128 МБ RAM."
        },
        {
          q: "Есть ли бесплатный пилотный период?",
          a: "Да, мы предлагаем бесплатное пилотное внедрение на до 30 устройств на 30 дней. Это позволяет оценить эффективность системы до принятия решения о покупке. Количество слотов ограничено — оставьте заявку для получения доступа."
        },
        {
          q: "Какое время поддержки и SLA?",
          a: "На тарифах Starter и Business — поддержка в рабочее время с временем реакции 4 часа. На тарифе Business — поддержка 24/7. Enterprise-план включает SLA 99.99%, выделенного менеджера и on-site поддержку."
        }
      ]
    },
    footer: {
      rights: "ТСМ — Техническая система мониторинга",
      zen: "Дзен"
    },
    notFound: {
      title: "Мы не сломались!",
      subtitle: "Но скоро всё починим. Эта страница пока в разработке, но мы работаем над ней прямо сейчас! 🛠️",
      backHome: "← Вернуться на главную",
      telegram: "Написать в Telegram",
      stats: [
        { value: "99.9%", label: "uptime системы" },
        { value: "24/7", label: "мониторинг работает" },
        { value: "∞", label: "возможностей впереди" }
      ]
    },
    case: {
      title: "Кейс внедрения ТСМ",
      subtitle: "Мониторинг банкоматов и терминалов — от идеи к результату",
      problem: {
        title: "Проблема",
        text: "Банки и ритейл-сети управляют тысячами терминальных устройств: банкоматами, платёжными терминалами, POS-системами. При этом мониторинг их состояния часто ведётся вручную, что приводит к простоям, потере доходов и росту затрат на обслуживание."
      },
      solution: {
        title: "Решение",
        text: "ТСМ — система мониторинга терминальной сети, которая автоматизирует контроль состояния устройств, прогнозирует сбои и снижает операционные расходы."
      },
      results: {
        title: "Результаты",
        items: [
          "Время простоя снижено с 6.2% до 0.8%",
          "Затраты на обслуживание уменьшены на 45%",
          "ROI 340% за первый год внедрения",
          "Время реакции на инцидент сокращено с 15 мин до 45 сек"
        ]
      },
      tech: {
        title: "Технологии",
        items: ["Node.js", "React", "PostgreSQL", "gRPC", "Protocol Buffers", "Docker"]
      },
      timeline: {
        title: "Хронология проекта",
        phases: [
          {
            phase: "Фаза 1: Анализ и проектирование",
            period: "Январь — Март 2025",
            items: ["Анализ существующей инфраструктуры", "Проектирование архитектуры ТСМ", "Выбор технологического стека", "Создание прототипа"]
          },
          {
            phase: "Фаза 2: Разработка ядра",
            period: "Апрель — Июнь 2025",
            items: ["Разработка протокола gRPC", "Создание агента мониторинга", "Backend-сервисы", "Базовая панель управления"]
          },
          {
            phase: "Фаза 3: Пилотное внедрение",
            period: "Июль — Сентябрь 2025",
            items: ["Тестирование на 50 устройствах", "Сбор метрик и обратной связи", "Оптимизация производительности", "Документирование"]
          },
          {
            phase: "Фаза 4: Масштабирование",
            period: "Октябрь 2025 — Настоящее время",
            items: ["Расширение до 500+ устройств", "AI-аналитика и прогнозирование", "Интеграция с SIEM", "Поддержка 24/7"]
          }
        ]
      },
      cta: {
        title: "Хотите такие же результаты?",
        subtitle: "Узнайте, как ТСМ может оптимизировать управление вашей терминальной инфраструктурой",
        button: "Запросить демо"
      }
    },
    pilot: {
      title: "Кейс внедрения",
      subtitle: "Пилотное внедрение системы мониторинга в крупном банке РФ с охватом более 1000 устройств",
      architecture: {
        title: "Архитектура решения",
        cards: [
          { title: "Агент на устройстве", desc: "Node.js + служба обновления с шифрованием. Работает на Windows и Linux." },
          { title: "Серверная часть", desc: "Express.js, WebSocket, RabbitMQ, PostgreSQL, Redis — отказоустойчивая архитектура." },
          { title: "Протокол связи", desc: "Бинарный протокол на основе Protobuf с ручным фреймингом и SHA-256/RSA аутентификацией." },
          { title: "Frontend", desc: "React-панель для инженеров поддержки с real-time мониторингом и управлением." }
        ]
      },
      challenges: {
        title: "Ключевые вызовы и решения",
        headers: ["Проблема", "Решение"],
        rows: [
          { problem: "Устройства за NAT, нет белых IP", solution: "Регистрация через исходящее WebSocket-соединение" },
          { problem: "Нестабильный интернет", solution: "Очередь команд в Redis + авто-повтор при восстановлении" },
          { problem: "Безопасность данных", solution: "SHA-256 (RSA) + CRC32 хеширование" },
          { problem: "Массовое обновление ПО", solution: "Групповая рассылка через RabbitMQ + контроль выполнения" }
        ]
      },
      results: {
        title: "Результаты внедрения",
        headers: ["Метрика", "До", "После", "Эффект"],
        rows: [
          { metric: "Время реакции", before: "15 мин", after: "45 сек", effect: "↓ 95%" },
          { metric: "Инциденты в месяц", before: "32", after: "6", effect: "↓ 81%" },
          { metric: "Время обновления ПО", before: "2 часа", after: "12 мин", effect: "↓ 90%" },
          { metric: "Выезды на объект", before: "8/мес", after: "1/мес", effect: "↓ 88%" },
          { metric: "Простой терминалов", before: "6.2%", after: "0.8%", effect: "↓ 87%" },
          { metric: "Кассовые разрывы", before: "12/мес", after: "1/мес", effect: "↓ 92%" },
          { metric: "OPEX", before: "₽2.4 млн/мес", after: "₽1.3 млн/мес", effect: "↓ 46%" }
        ]
      },
      economic: {
        title: "Экономический эффект",
        items: [
          { value: "340%", label: "ROI за первый год" },
          { value: "5 мес", label: "Срок окупаемости" },
          { value: "₽13.2М", label: "Экономия за год" }
        ]
      },
      quote: "«Раньше при каждой проблеме нужно было ехать на место. Теперь большинство инцидентов решается за 2 минуты удалённо. Это изменило нашу работу кардинально.»",
      quoteAuthor: "— Инженер поддержки, филиал г. Казань",
      cta: "Готов к новым проектам!\nУчаствую в пилотных реализациях систем мониторинга, удалённого управления и IoT-инфраструктуры. Готов делиться опытом и внедрять решения с нуля."
    },
    roadmap: {
      title: "Roadmap развития ТСМ",
      subtitle: "Стратегический план развития системы мониторинга. История двух версий и перспективы.",
      heroTitle: "Перспективы развития",
      heroSubtitle: "Стратегическая дорожная карта развития системы мониторинга. От базового контроля до AI-аналитики и экосистемы.",
      statusPlanned: "Запланировано",
      
      // Сравнение версий
      version1: {
        title: "Версия 1.0 (2024)",
        badge: "Первая версия",
        features: [
          "Принял участие в разработке в банке ГПБ",
          "Тиражирование на 1000+ устройств терминальной сети",
          "Стек: C# (агент), C++ (сервер)",
          "Служба .NET Framework",
          "Протокол ASN.1 TLV",
          "Базовый мониторинг статуса банкоматов и терминалов"
        ]
      },
      version2: {
        title: "Версия 2.0 (2025)",
        badge: "Современная",
        features: [
          "Полностью переработанная архитектура",
          "Единый язык разработки — JavaScript (Node.js)",
          "Современный протокол gRPC + Protobuf",
          "Высокая производительность и строгая типизация",
          "Кроссплатформенный агент (Windows + Linux)",
          "React-панель управления с тёмной темой",
          "Предиктивная AI-аналитика",
          "Кассовое прогнозирование"
        ]
      },
      
      phases: [
        {
          period: "2024",
          title: "Версия 1.0 — Запуск в ГПБ",
          status: "completed",
          statusLabel: "Завершено",
          items: [
            "Разработка первой версии системы мониторинга",
            "Стек: C#, C++, .NET Framework, ASN.1 TLV",
            "Тиражирование на 1000+ устройств терминальной сети",
            "Базовый мониторинг статуса банкоматов и терминалов",
            "Первые результаты: снижение простоев на 40%"
          ]
        },
        {
          period: "Июнь 2025",
          title: "Аспирантская научная работа — РАНХиГС",
          status: "progress",
          statusLabel: "В процессе",
          items: [
            "Зачисление в аспирантуру РАНХиГС",
            "Тема: «Разработка методов и алгоритмов передачи финансовых сообщений в условиях цифровой трансформации банковских систем»",
            "Научный руководитель: Голосов Павел Евгеньевич, канд. техн. наук, директор ИОН РАНХиГС",
            "Научная новизна: новые методы адаптивного кодирования, алгоритмы гарантированной доставки, модель надёжности каналов",
            "Практическая база — ТСМ: реализация разработанных методов в действующей системе",
            "Публикация результатов в рецензируемых изданиях, подготовка диссертации"
          ]
        },
        {
          period: "2025",
          title: "Версия 2.0 — Актуальная версия на новом стеке",
          status: "completed",
          statusLabel: "Завершено",
          items: [
            "Полная архитектурная переработка системы",
            "Переход на единый стек — JavaScript (Node.js)",
            "Замена протокола ASN.1 TLV на gRPC + Protobuf",
            "Создание React-панели управления",
            "Внедрение предиктивной AI-аналитики",
            "Кроссплатформенный агент для Windows и Linux",
            "ROI 340%, снижение OPEX на 45%"
          ]
        },
        {
          period: "Апрель 2026",
          title: "Презентация на акселераторе ВТБ",
          status: "completed",
          statusLabel: "Завершено",
          items: [
            "Презентация проекта на акселераторе ПАО ВТБ",
            "Демонстрация результатов внедрения",
            "Привлечение инвестиций для масштабирования",
            "Партнёрство с крупными финансовыми институтами"
          ]
        },
        {
          period: "Май 2026",
          title: "Топ-10 акселератора ПСБ",
          status: "completed",
          statusLabel: "Завершено",
          items: [
            "Участие в акселераторе Промсвязьбанк",
            "Вход в топ-10 лучших проектов акселератора",
            "Расширение клиентской базы",
            "Готовность к коммерческому масштабированию"
          ]
        },
        {
          period: "Июль 2026",
          title: "Научная публикация — ГУУ",
          status: "completed",
          statusLabel: "Завершено",
          items: [
            "Публикация в журнале на научно-практической конференции ГУУ",
            "Тема: «Разработка и внедрение распределённой системы мониторинга для терминальной инфраструктуры: опыт применения gRPC в финансовом секторе»",
            "Опыт миграции с ASN.1 TLV на gRPC",
            "Практические результаты для финансового сектора"
          ]
        },
        {
          period: "Октябрь 2026",
          title: "Публикация симулятора нагрузки — GitHub",
          status: "completed",
          statusLabel: "Завершено",
          items: [
            "Открытие исходного кода симулятора нагрузочного тестирования",
            "Публикация на GitHub: github.com/aovakur/Simulator_terminal_monitoring",
            "Open Source лицензия",
            "Возможность тестирования производительности системы под нагрузкой",
            "Эмуляция поведения множества терминальных устройств"
          ]
        },
        {
          period: "Q4 2026",
          title: "AI-аналитика и кассовое прогнозирование",
          status: "planned",
          statusLabel: "Запланировано",
          items: [
            "ML-модели для прогнозирования кассовых разрывов",
            "Интеграция с внешними источниками данных",
            "Автоматическая генерация рекомендаций по пополнению",
            "Прогноз потребности в наличных на 7-30 дней"
          ]
        },
        {
          period: "2027",
          title: "Масштабирование и экосистема",
          status: "planned",
          statusLabel: "Запланировано",
          items: [
            "Расширение на новые типы устройств",
            "Мультирегиональное развёртывание",
            "Открытый API для партнёрской интеграции",
            "Микросервисная архитектура",
            "Поддержка SaaS-модели"
          ]
        }
      ],
      kpi: {
        title: "Ключевые показатели развития",
        items: [
          { value: "1000+", label: "устройств в мониторинге" },
          { value: "340%", label: "ROI за первый год" },
          { value: "45%", label: "снижение OPEX" },
          { value: "99.9%", label: "uptime системы" }
        ]
      }
    },
    docs: {
      title: "Документация",
      subtitle: "Протокол обмена данными, API и примеры взаимодействия системы мониторинга",
      proto: "Protobuf",
      swagger: "Swagger API",
      interaction: "Пример взаимодействия",
      swaggerTitle: "Swagger API",
      swaggerDesc: "Полная документация REST API системы мониторинга. Доступны все endpoints для управления устройствами, получения статуса и отправки команд.",
      interactionTitle: "Пример взаимодействия",
      interactionDesc: "Руководство по тестированию подключения устройств к серверу TCM. Описаны протоколы обмена, команды и примеры взаимодействия.",
      quickStart: {
        title: "🚀 Быстрый старт",
        setup: {
          title: "1. Настройка подключения",
          desc: "Укажите параметры подключения к серверу:"
        },
        run: {
          title: "2. Запуск тестирования"
        }
      },
      deviceBehavior: {
        title: "🎯 Поведение устройств",
        desc: "При подключении каждое устройство отправляет <strong>DeviceEvent</strong> с типом <code>CONNECTED</code>:",
        steps: [
          {
            desc: "Отправляет через <code>SendMessage</code> (stream):",
            items: [
              "<strong>DeviceEvent</strong> — событие подключения (<code>eventtype: \"CONNECTED\"</code>)",
              "<strong>DeviceStatus</strong> — текущий статус устройства (devices, os, usb, disks)"
            ]
          },
          {
            desc: "Готово принимать команды от сервера через <code>SendMessage</code>:",
            items: [
              "<code>GetDeviceStatusRequest</code> → ответ: <code>DeviceStatus</code>",
              "<code>GetRegistryBranchRequest</code> → ответ: <code>RegistryBranchResponse</code>",
              "<code>GetRegistryValueRequest</code> → ответ: <code>RegistryValueResponse</code>",
              "<code>LogRequest</code> → ответ через <code>GetLog</code> (stream FilePart)",
              "<code>GetDateTime</code> → ответ: <code>TransportMessage</code>",
              "<code>SetDateTime</code> → установка времени на устройстве",
              "<code>Restart</code> → перезагрузка устройства",
              "<code>FilePart</code> → приём файлов от сервера"
            ]
          },
          {
            desc: "Может отправлять события в любое время:",
            items: [
              "<code>DeviceEvent</code> с типом <code>DISCONNECTED</code> при отключении",
              "<code>FilePartAck</code> — подтверждение получения части файла",
              "<code>CommandResponse</code> — результат выполнения команды"
            ]
          }
        ]
      },
      protocol: {
        title: "📡 Протокол обмена",
        transport: {
          title: "Транспортный уровень",
          desc: "Все сообщения передаются в обёртке <strong>TransportMessage</strong>:",
          headers: ["Поле", "Тип", "Описание"],
          fields: [
            { field: "uid", type: "string", desc: "128-bit UUID (16 байт)" },
            { field: "sessionid", type: "string", desc: "Идентификатор сессии" },
            { field: "deviceid", type: "string", desc: "Идентификатор устройства" },
            { field: "cmdid", type: "uint32", desc: "Задача" },
            { field: "timestamp", type: "int64", desc: "Временная метка" },
            { field: "payload", type: "Payload", desc: "Полезная нагрузка (oneof)" },
            { field: "requestid", type: "uint32", desc: "ID запроса (для RPC)" },
            { field: "responseto", type: "uint32", desc: "Ссылка на request_id, если это ответ" },
            { field: "crc", type: "uint32", desc: "CRC32 от сериализованного payload" },
            { field: "success", type: "string", desc: "Результат успеха, если есть" },
            { field: "error", type: "string", desc: "Результат ошибки, если есть" }
          ]
        },
        commands: {
          title: "Команды Payload (oneof)",
          desc: "Полезная нагрузка может содержать одну из следующих команд:",
          headers: ["Сообщение", "Описание"],
          items: [
            { msg: "DeviceStatus", desc: "Статус устройств (массив)" },
            { msg: "FilePart", desc: "Передача части файла" },
            { msg: "LogRequest", desc: "Запрос лог-файлов" },
            { msg: "GetDeviceStatusRequest", desc: "Запрос статуса устройства" },
            { msg: "GetDateTime", desc: "Запрос текущего времени" },
            { msg: "SetDateTime", desc: "Установка времени" },
            { msg: "FilePartAck", desc: "Подтверждение части файла" },
            { msg: "GetRegistryRequest", desc: "Запрос всего реестра" },
            { msg: "RegistryResponse", desc: "Ответ с записями реестра" },
            { msg: "GetRegistryBranchRequest", desc: "Запрос ветки реестра" },
            { msg: "RegistryBranchResponse", desc: "Ответ с веткой реестра" },
            { msg: "GetRegistryValueRequest", desc: "Запрос одного значения" },
            { msg: "RegistryValueResponse", desc: "Ответ с одним значением" },
            { msg: "DeviceEvent", desc: "Событие подключения/отключения" },
            { msg: "Restart", desc: "Перезагрузка устройства" },
            { msg: "CommandResponse", desc: "Ответ на команду" }
          ]
        },
        examples: [
          { title: "Пример: DeviceStatus" },
          { title: "Пример: DeviceEvent (подключение устройства)" },
          { title: "Пример: LogRequest (запрос логов)" },
          { title: "Пример: GetRegistryBranchRequest (запрос ветки реестра)" }
        ]
      },
      rpc: {
        title: "🔌 RPC методы",
        headers: ["Метод", "Вход", "Выход", "Описание"],
        methods: [
          { method: "SendMessage", in: "stream TransportMessage", out: "stream TransportMessage", desc: "Двусторонний стриминг для всех типов команд" },
          { method: "SendRequest", in: "TransportMessage", out: "TransportMessage", desc: "Однократная отправка с ответом" },
          { method: "DeviceEvent", in: "TransportMessage", out: "stream TransportMessage", desc: "Подписка на события в реальном времени" },
          { method: "GetRegistryBranch", in: "GetRegistryBranchRequest", out: "RegistryBranchResponse", desc: "Запрос ветки реестра (например: \"device/\")" },
          { method: "GetDateTime", in: "GetDateTime", out: "TransportMessage", desc: "Запрос времени с устройства" },
          { method: "GetDeviceStatus", in: "GetDeviceStatusRequest", out: "DeviceStatus", desc: "Статус устройств с параметрами" },
          { method: "SendFilePart", in: "FilePart", out: "FilePartAck", desc: "Передача части файла на сервер" },
          { method: "GetLog", in: "LogRequest", out: "stream FilePart", desc: "Запрос лог-файлов с фильтрацией" }
        ]
      },
      diagrams: {
        title: "📊 Диаграммы обмена",
        connect: { title: "Подключение устройства (DeviceEvent)" },
        file: { title: "Передача файла (SendFilePart)" },
        log: { title: "Запрос логов (GetLog)" },
        stream: { title: "Двусторонний стриминг (SendMessage)" },
        stepLabels: {
          connect: "WebSocket connect",
          connected: "Connection established",
          sendOpen: "SendMessage(stream open)",
          sendFilePart1: "SendFilePart",
          filePartAck: "FilePartAck",
          fileCollected: "Файл собран из частей",
          getLog: "GetLog",
          streamFilePart: "stream FilePart",
          logReceived: "Лог получен по частям",
          streamOpen: "Stream open (двусторонний канал)",
          streamClose: "Stream close"
        }
      },
      monitoring: {
        title: "📊 Мониторинг подключения",
        desc: "Во время тестирования отображается статистика подключения в реальном времени:",
        stats: "📊 === CONNECTION STATS ===\n   Total devices: 1000\n   Connected: 998\n   Disconnected: 2\n   Work directory: ./test/devices\n   =========================="
      }
    },
    resources: {
      title: "Документы и публикации",
      subtitle: "Свидетельство о регистрации ПО, статьи и материалы о проекте ТСМ",
      certificate: {
        title: "Свидетельство о регистрации ПО",
        subtitle: "Официальная регистрация программы для ЭВМ в Роспатенте",
        download: "Скачать PDF",
        view: "Просмотреть",
        sectionTitle: "Свидетельство о регистрации программного обеспечения",
        badge: "✓ Зарегистрировано",
        name: "ТСМ — Техническая система мониторинга",
        fields: {
          number: "Номер свидетельства",
          date: "Дата регистрации",
          type: "Тип"
        },
        values: {
          type: "Программное обеспечение"
        },
        description: "Программный комплекс для мониторинга терминальной сети, обеспечивающий контроль банкоматов, платёжных терминалов, POS-устройств и IoT-инфраструктуры в реальном времени.",
        openReferat: "Открыть реферат →"
      },
      publication: {
        title: "Научная публикация",
        badge: "◈ 2026",
        name: "Опыт применения gRPC в финансовом секторе на научной конференции",
        description: "Статья о практическом опыте внедрения протокола gRPC и Protocol Buffers для построения высокопроизводительной системы мониторинга терминальной сети в финансовом секторе. Рассмотрены вопросы безопасности, производительности и масштабируемости бинарного протокола обмена данными.",
        openArticle: "Открыть статью →"
      },
      simulator: {
        title: "Симулятор нагрузочного тестирования",
        badge: "○ Open Source",
        name: "Simulator Terminal Monitoring",
        description: "Симулятор нагрузочного тестирования для системы мониторинга терминальной сети. Позволяет эмулировать поведение множества терминальных устройств и тестировать производительность системы под нагрузкой.",
        github: "Перейти на GitHub →"
      },
      articles: {
        title: "Статьи в Дзене",
        items: [
          {
            badge: "📝 Статья",
            name: "Опыт применения gRPC в финансовом секторе",
            desc: "Практический опыт внедрения протокола gRPC и Protocol Buffers для построения высокопроизводительной системы мониторинга терминальной сети. Вопросы безопасности, производительности и масштабируемости.",
            readBtn: "Читать в Дзене →"
          },
          {
            badge: "📝 Статья",
            name: "От Windows к кроссплатформе: как я переписал систему мониторинга с нуля",
            desc: "История миграции с Windows-only решения на кроссплатформенную архитектуру. Рефакторинг с использованием Node.js, React и современных технологий.",
            readBtn: "Читать в Дзене →"
          },
          {
            badge: "📝 Статья",
            name: "Опыт применения gRPC в финансовом секторе на научной конференции",
            desc: "Статья о практическом опыте внедрения протокола gRPC и Protocol Buffers для построения высокопроизводительной системы мониторинга терминальной сети в финансовом секторе. Рассмотрены вопросы безопасности, производительности и масштабируемости бинарного протокола обмена данными.",
            readBtn: "Читать в Дзене →"
          }
        ]
      },
      cta: "Нужна подробная информация?\nСвяжитесь с нами для получения полной технической документации и обсуждения внедрения."
    },
    referat: {
      title: "Реферат — ТСМ",
      subtitle: "Техническая система мониторинга — описание, архитектура и результаты внедрения",
      introduction: {
        title: "Введение",
        text: "Современные банки и ритейл-сети управляют тысячами терминальных устройств. Эффективный мониторинг их состояния критически важен для обеспечения бесперебойной работы и минимизации затрат."
      },
      architecture: {
        title: "Архитектура системы",
        text: "ТСМ построена на микросервисной архитектуре с использованием gRPC для обмена данными между устройствами и сервером. Система включает агент на устройстве, серверную часть и веб-панель управления."
      },
      technology: {
        title: "Технологии",
        text: "Backend: Node.js (Express, Sequelize), PostgreSQL, Redis, RabbitMQ. Frontend: React + Vite. Протокол: gRPC + Protocol Buffers. Агент: кроссплатформенный, работает на Windows и Linux."
      },
      results: {
        title: "Результаты",
        text: "Внедрение ТСМ позволяет снизить затраты на обслуживание на 45%, сократить время простоя с 6.2% до 0.8%, повысить ROI до 340% за первый год."
      },
      conclusion: {
        title: "Заключение",
        text: "ТСМ демонстрирует высокую эффективность в мониторинге терминальной инфраструктуры и может быть адаптирована под различные сценарии использования."
      },
      eLibrary: "Публикация на eLibrary",
      sectionNames: [
        "Название программы",
        "Назначение программы",
        "Область применения",
        "Основные функции",
        "Технические характеристики",
        "Выгоды для бизнеса",
        "Уникальные особенности",
        "Заключение"
      ],
      sectionContent: {
        name: "«ТСМ — Техническая система мониторинга терминальной сети»",
        purpose: "Программа предназначена для обеспечения бесперебойной, безопасной и эффективной работы банкоматов, платёжных терминалов, POS-устройств и других критически важных систем.",
        scope: [
          "Финансовая сфера (банки, платёжные системы)",
          "Розничная торговля (POS-терминалы)",
          "Госучреждения и иные организации с распределённой терминальной инфраструктурой"
        ],
        functions: [
          "<strong>Оперативный контроль состояния устройств:</strong> мониторинг онлайн-статуса, загрузки CPU, памяти, температуры, сетевого соединения.",
          "<strong>Предотвращение простоев:</strong> раннее выявление сбоев, минимизация времени реакции, снижение финансовых потерь.",
          "<strong>Управление ПО:</strong> централизованное обновление, удалённая диагностика, контроль версий.",
          "<strong>Безопасность:</strong> обнаружение атак, контроль целостности, блокировка скомпрометированных устройств.",
          "<strong>Аналитика и оптимизация:</strong> сбор статистики по загрузке, формирование отчётов, планирование масштабирования.",
          "<strong>Соблюдение регламентов:</strong> аудит, ведение журналов событий, соответствие нормативам.",
          "<strong>Упрощение обслуживания:</strong> удалённая диагностика, автоматизация рутинных операций, учёт заявок на обслуживание."
        ],
        techArchitecture: [
          "<strong>Backend:</strong> Node.js (Express, Sequelize), PostgreSQL, Redis, RabbitMQ",
          "<strong>Frontend:</strong> React + Vite, Bootstrap",
          "<strong>API:</strong> REST + Swagger, gRPC для взаимодействия устройств",
          "<strong>Протокол обмена данными:</strong> gRPC + Protocol Buffers (Protobuf)",
          "<strong>Агент мониторинга:</strong> кроссплатформенное приложение на Node.js, совместимое с Windows и Linux"
        ],
        techDelivery: [
          "<strong>On-Premise (коробочное решение):</strong> развёртывание в инфраструктуре клиента, полный контроль над данными, интеграция с внутренними системами (AD, CRM, SIEM), поддержка аудита и регуляторных требований. Подходит для банков и госучреждений.",
          "<strong>SaaS (облачное решение):</strong> быстрое развёртывание (за несколько часов), автоматические обновления, гибкая подписка (pay-as-you-go), доступ из любой точки мира."
        ],
        techProtocol: {
          advantages: "<strong>Преимущества:</strong> высокая производительность, строгая типизация, поддержка стриминга, компактные сообщения, генерация кода для множества языков.",
          messages: [
            "<strong>DeviceEvent</strong> — событие изменения состояния устройства (подключение/отключение)",
            "<strong>DeviceInfo</strong> — описание устройства (статус, модель, версия ПО, температура, заряд батареи и т.д.)",
            "<strong>DeviceStatus</strong> — информация о состоянии одного или нескольких устройств",
            "<strong>FilePart / FilePartAck</strong> — передача файлов по частям и подтверждение получения",
            "<strong>LogRequest</strong> — запрос логов с фильтрацией по типу, времени, компоненту и уровню",
            "<strong>RegistryResponse / RegistryBranchResponse</strong> — ответы с параметрами реестра устройства",
            "<strong>Restart</strong> — команда перезагрузки устройства",
            "<strong>TransportMessage</strong> — основная обёртка для всех сообщений (содержит UUID, ID сессии, временную метку, полезную нагрузку и т.д.)"
          ],
          services: [
            "<strong>GetDateTime</strong> — запрос текущего времени с устройства",
            "<strong>SetDateTime</strong> — установка времени на устройстве",
            "<strong>GetDeviceStatus</strong> — получение статуса устройств",
            "<strong>GetRegistry / GetRegistryBranch / GetRegistryValue</strong> — запросы параметров реестра",
            "<strong>FilePartStream</strong> — двусторонний стрим для передачи файлов",
            "<strong>LogRequest</strong> — запрос логов",
            "<strong>DeviceEventStream</strong> — стрим событий подключения/отключения",
            "<strong>RestartDevice</strong> — отправка команды перезагрузки"
          ]
        },
        benefits: [
          "Снижение затрат на обслуживание за счёт проактивного мониторинга",
          "Повышение доступности сервисов (больше работающих терминалов, меньше жалоб)",
          "Быстрое реагирование на инциденты (уведомления, автоматические сценарии)",
          "Прозрачность данных для анализа и стратегического планирования",
          "Соответствие требованиям безопасности и регуляторов"
        ],
        unique: [
          "<strong>Гибкость развёртывания:</strong> поддержка On-Premise и SaaS",
          "<strong>Кроссплатформенность:</strong> агент работает на Windows и Linux",
          "<strong>Эффективность обмена данными:</strong> использование gRPC и Protobuf для компактной и быстрой передачи данных",
          "<strong>Масштабируемость:</strong> архитектура позволяет легко расширять систему при росте числа устройств",
          "<strong>Надёжность:</strong> механизмы подтверждения получения данных (CRC32), стриминг для больших файлов и логов"
        ],
        conclusion: "«Техническая система мониторинга терминальной сети» — это современное решение для контроля и управления распределёнными терминальными устройствами. Сочетание высокой производительности (gRPC/Protobuf), гибкости развёртывания (On-Premise/SaaS) и богатого функционала делает программу оптимальным выбором для организаций, требующих бесперебойной работы критической инфраструктуры."
      },
      backToDocs: "← Вернуться к документам"
    },
    demo: {
      title: "Запросить демонстрацию",
      subtitle: "Заполните форму и мы свяжемся с вами для организации презентации системы",
      name: "Имя",
      namePlaceholder: "Ваше имя",
      company: "Компания",
      companyPlaceholder: "Название компании",
      email: "Email",
      emailPlaceholder: "email@company.ru",
      phone: "Телефон",
      phonePlaceholder: "+7 (___) ___-__-__",
      devices: "Количество устройств",
      devicesPlaceholder: "Выберите диапазон",
      devicesOptions: [
        "Выберите диапазон",
        "1 — 100 устройств",
        "100 — 500 устройств",
        "500 — 1 000 устройств",
        "1 000 — 5 000 устройств",
        "Более 5 000 устройств"
      ],
      message: "Комментарий",
      messagePlaceholder: "Расскажите о вашей инфраструктуре и задачах...",
      submit: "Запросить демо",
      submitting: "Отправка...",
      cancel: "Отмена",
      success: "Спасибо! Мы свяжемся с вами в ближайшее время.",
      nameError: "Пожалуйста, введите ваше имя",
      companyError: "Пожалуйста, введите название компании",
      emailError: "Пожалуйста, введите корректный email",
      phoneError: "Пожалуйста, введите номер телефона",
      sendError: "Не удалось отправить заявку. Попробуйте позже.",
      desc: "Заполните форму и мы покажем систему в действии"
    },
    privacy: {
      title: "Политика конфиденциальности",
      titleEn: "Privacy Policy"
    },
    comingSoon: {
      title: "Скоро будет доступно",
      description: "Раздел оформления заявок временно недоступен. Мы работаем над добавлением этой функции. Следите за обновлениями!",
      progress: "Прогресс разработки"
    }
  },
  en: {
    nav: {
      home: "Home",
      case: "Case Study",
      roadmap: "Roadmap",
      docs: "Documentation",
      resources: "Publications",
      pricing: "Pricing",
      requestDemo: "Request Demo",
      menu: "Menu"
    },
    theme: {
      light: "Light theme",
      dark: "Dark theme"
    },
    loading: "Loading...",
    hero: {
      title: "Terminal Network<br />Monitoring System",
      subtitle: "Professional solution for controlling ATMs, payment terminals, POS devices and IoT infrastructure. Reduce OPEX by 45%, ROI 340%.",
      requestDemo: "Request Demo",
      learnMore: "Learn More"
    },
    stats: {
      roi: "Average ROI in first year",
      opex: "Maintenance cost reduction",
      payback: "Implementation payback period"
    },
    features: {
      title: "Key Features",
      subtitle: "Comprehensive monitoring system for uninterrupted terminal infrastructure operation",
      operationalControl: "Real-time Control",
      operationalControlDesc: "Monitor status, CPU usage, memory, temperature and network in real-time. All devices in a single control panel.",
      preventDowntime: "Downtime Prevention",
      preventDowntimeDesc: "Early detection of failures and automatic notifications. Response time reduction from 15 minutes to 45 seconds.",
      softwareManagement: "Software Management",
      softwareManagementDesc: "Centralized updates, remote diagnostics and version control on all network devices.",
      security: "Security",
      securityDesc: "Attack detection, data integrity control, SHA-256 encryption and compromised device blocking.",
      aiAnalytics: "AI Analytics",
      aiAnalyticsDesc: "Predictive analytics based on machine learning. Failure prediction 24-48 hours before occurrence.",
      cashAnalytics: "Cash Analytics",
      cashAnalyticsDesc: "Cash gap forecasting, replenishment optimization and cash demand forecasting for 30 days."
    },
    businessBenefits: {
      title: "Business Benefits",
      subtitle: "Measurable economic effect from implementing the monitoring system",
      costReduction: "Cost Reduction",
      costReductionDesc: "Proactive monitoring reduces maintenance costs by 45%. Automation of routine operations reduces field personnel needs by 88%.",
      availability: "Increased Availability",
      availabilityDesc: "Terminal downtime reduced from 6.2% to 0.8%. Monthly incidents drop from 32 to 6. Customers receive uninterrupted service.",
      fastResponse: "Fast Response",
      fastResponseDesc: "Automatic notifications and response scenarios. Average incident response time - 45 seconds instead of 15 minutes.",
      transparency: "Transparency & Reporting",
      transparencyDesc: "Complete utilization statistics, management reports, data for strategic planning and scaling."
    },
    techStack: {
      title: "Technology Stack",
      subtitle: "Modern architecture ensuring reliability and performance",
      backend: "Backend",
      backendDesc: "Node.js (Express, Sequelize), PostgreSQL for data storage, Redis for caching and queues, RabbitMQ for message exchange.",
      frontend: "Frontend",
      frontendDesc: "React + Vite for fast control panel. Bootstrap 5 for responsive interface. Dark and light themes.",
      api: "API & Protocols",
      apiDesc: "REST API with Swagger documentation. gRPC and Protocol Buffers for device-server communication - high performance and strict typing.",
      agent: "Agent",
      agentDesc: "Cross-platform agent on Node.js for Windows and Linux. Works through NAT, command queue on connection loss, auto-recovery."
    },
    dashboard: {
      title: "Control Panel",
      subtitle: "Monitoring system interface for support engineers"
    },
    systemComponents: {
      title: "System Components",
      subtitle: "Internal monitoring, logging and task management mechanisms",
      terminalEvents: "Terminal Events",
      terminalEventsDesc: "Logging all events: connect/disconnect, status changes, control commands in real-time.",
      clientLog: "Client Log",
      clientLogDesc: "Detailed logs of agent operation on device: diagnostics, errors, connection status to server.",
      serverLog: "Server Log",
      serverLogDesc: "Server logs of command processing, WebSocket connections, interaction with PostgreSQL and RabbitMQ.",
      rabbitMq: "RabbitMQ Task Queue",
      rabbitMqDesc: "Management of command and event queues: task distribution, priorities, delivery guarantee."
    },
    deployment: {
      title: "Deployment Options",
      subtitle: "Choose the deployment option that suits your requirements",
      onPremise: "On-Premise",
      onPremiseDesc: "Fully deployed in client infrastructure. Suitable for banks, government institutions and companies with high security requirements.",
      onPremiseFeatures: [
        "Local server deployment",
        "Full data control",
        "Integration with AD, CRM, SIEM",
        "Audit support"
      ],
      saas: "SaaS (Cloud)",
      saasDesc: "Ready-to-use cloud solution. Quick start without server investments.",
      saasFeatures: [
        "Deployment in hours",
        "Automatic updates",
        "Flexible subscription",
        "Access from anywhere"
      ]
    },
    pricing: {
      title: "Pricing Plans",
      subtitle: "Choose the right plan for your infrastructure",
      order: "Order",
      starter: {
        name: "Starter",
        description: "For small networks up to 100 devices",
        price: "$600",
        period: "/month",
        features: [
          "Up to 100 devices",
          "Basic monitoring",
          "Email notifications",
          "Business hours support",
          "Software updates"
        ],
        cta: "Get Started"
      },
      business: {
        name: "Business",
        description: "For medium networks up to 1000 devices",
        price: "$2,000",
        period: "/month",
        popular: "Popular",
        features: [
          "Up to 1000 devices",
          "Full monitoring + AI",
          "All channel notifications",
          "24/7 Support",
          "Priority updates",
          "Cash analytics",
          "API access"
        ],
        cta: "Choose Plan"
      },
      enterprise: {
        name: "Enterprise",
        description: "For large networks without limits",
        price: "Custom",
        period: "",
        features: [
          "Unlimited devices",
          "Full functionality",
          "Dedicated manager",
          "SLA 99.99%",
          "Custom integration",
          "Team training",
          "On-site support"
        ],
        cta: "Contact Us"
      }
    },
    cta: {
      title: "Ready to Start?",
      subtitle: "Request a system demo and learn how TCM can optimize your terminal infrastructure management",
      button: "Request Demo"
    },
    trustBadges: {
      title: "Reliability & Compliance",
      subtitle: "Officially registered software meeting Russian market requirements",
      items: [
        {
          icon: "📜",
          title: "Rospatent Certificate",
          desc: "Program registered with Rospatent. Official intellectual property protection."
        },
        {
          icon: "🔒",
          title: "152-FZ Compliance",
          desc: "Full compliance with personal data law. Data stored within Russian Federation."
        },
        {
          icon: "🏢",
          title: "On-Premise",
          desc: "Deploy on your servers. Data never leaves your infrastructure."
        },
        {
          icon: "🇷🇺",
          title: "Russian Development",
          desc: "Full development cycle in Russia. Included in the State Register of Russian Software."
        },
        {
          icon: "🛡️",
          title: "Financial Sector",
          desc: "Meets Central Bank of Russia requirements. Suitable for banks and payment organizations."
        },
        {
          icon: "📊",
          title: "1000+ Devices",
          desc: "System successfully monitors thousands of terminals in pilot deployments."
        }
      ]
    },
    roiCalculator: {
      title: "Calculate Your Savings",
      subtitle: "Find out how much TCM will save with your infrastructure",
      inputs: {
        devices: { label: "Number of devices", placeholder: "500" },
        visitCost: { label: "Engineer visit cost (₽)", placeholder: "5,000" },
        downtimeCost: { label: "Downtime cost per device per hour (₽)", placeholder: "2,000" },
        monthlyIncidents: { label: "Incidents per month", placeholder: "100" }
      },
      results: {
        annualSavings: "Annual Savings",
        downtimeReduction: "Downtime Reduction",
        roi: "Year 1 ROI",
        paybackMonths: "Payback Period",
        perDevice: "Savings per Device",
        savings: "₽",
        percent: "%",
        months: "mo",
        devices: "dev."
      },
      note: "Calculation based on average TCM implementation metrics. Actual results may vary."
    },
    comparison: {
      title: "Comparison with Alternatives",
      subtitle: "Why TCM is better than general-purpose monitoring systems for terminal infrastructure",
      table: {
        headers: ["Criterion", "TCM", "Zabbix", "SolarWinds", "Manual Monitoring"],
        rows: [
          { feature: "Terminal & ATM monitoring", tcm: "✓ Out of the box", zabbix: "✗ Setup needed", solarwinds: "✗ Not available", manual: "✗ Not available" },
          { feature: "gRPC protocol", tcm: "✓ High speed", zabbix: "✗ Not available", solarwinds: "✗ Not available", manual: "✗ Not available" },
          { feature: "NAT traversal", tcm: "✓ Built-in", zabbix: "✗ Setup needed", solarwinds: "✗ Not available", manual: "✗ Not available" },
          { feature: "Cash analytics", tcm: "✓ AI forecast", zabbix: "✗ Not available", solarwinds: "✗ Not available", manual: "✗ Not available" },
          { feature: "On-Premise", tcm: "✓", zabbix: "✓", solarwinds: "✓", manual: "—" },
          { feature: "152-FZ / Central Bank", tcm: "✓", zabbix: "✗", solarwinds: "✗", manual: "—" },
          { feature: "Russian Software Register", tcm: "✓", zabbix: "✗", solarwinds: "✗", manual: "—" },
          { feature: "Implementation cost", tcm: "Medium", zabbix: "Low*", solarwinds: "High", manual: "Very high" },
          { feature: "*Additional setup & maintenance costs", tcm: "", zabbix: "", solarwinds: "", manual: "" }
        ]
      },
      note: "*Zabbix is free but requires significant investment in setup and maintenance"
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Answers to common questions about TCM system deployment and operation",
      items: [
        {
          q: "How long does TCM implementation take?",
          a: "Standard implementation for a network of up to 500 devices takes 2-4 weeks. This includes server installation, device connection, notification setup, and team training. For larger networks — up to 8 weeks with phased connection."
        },
        {
          q: "Can I deploy TCM on my own servers?",
          a: "Yes, On-Premise is the primary delivery format. The system deploys in your infrastructure, data never leaves your perimeter. Supports deployment on Linux servers of any configuration."
        },
        {
          q: "Does the system comply with 152-FZ and Central Bank requirements?",
          a: "Yes, TCM fully complies with Federal Law No. 152-FZ on personal data. Data is stored within the Russian Federation. The solution is suitable for banks and payment organizations subject to Central Bank regulatory requirements."
        },
        {
          q: "Can I integrate TCM with our SIEM system?",
          a: "Yes, the system provides REST API and supports integration with popular SIEM systems (Splunk, ELK Stack, ArcSight). Integration with Active Directory, CRM systems, and ticketing systems is also possible."
        },
        {
          q: "What if we already have Zabbix or another monitoring system?",
          a: "TCM does not replace, but complements general-purpose systems. Zabbix monitors servers and network, while TCM monitors specialized terminal devices (ATMs, payment terminals, IoT). API integration allows combining data in a unified dashboard."
        },
        {
          q: "What infrastructure is required for TCM?",
          a: "Minimum configuration: 2 vCPU, 4 GB RAM, 50 GB SSD for TCM server. PostgreSQL 14+ and Redis for production deployment. TCM agent runs on any Linux device with 128 MB RAM."
        },
        {
          q: "Is there a free pilot period?",
          a: "Yes, we offer a free pilot deployment for up to 30 devices for 30 days. This allows you to evaluate the system before making a purchasing decision. Slot数量有限 — leave a request for access."
        },
        {
          q: "What support and SLA do you provide?",
          a: "Starter and Business plans include business hours support with 4-hour response time. Business plan includes 24/7 support. Enterprise plan includes 99.99% SLA, dedicated manager, and on-site support."
        }
      ]
    },
    footer: {
      rights: "TCM — Technical Monitoring System",
      zen: "Zen"
    },
    notFound: {
      title: "We're not broken!",
      subtitle: "But we'll fix it soon. This page is still under development, but we're working on it right now! 🛠️",
      backHome: "← Back to Home",
      telegram: "Write on Telegram",
      stats: [
        { value: "99.9%", label: "system uptime" },
        { value: "24/7", label: "monitoring works" },
        { value: "∞", label: "features ahead" }
      ]
    },
    case: {
      title: "TCM Implementation Case",
      subtitle: "ATM and terminal monitoring — from idea to results",
      problem: {
        title: "Problem",
        text: "Banks and retail networks manage thousands of terminal devices: ATMs, payment terminals, POS systems. However, monitoring their status is often done manually, leading to downtime, revenue loss, and increased maintenance costs."
      },
      solution: {
        title: "Solution",
        text: "TCM — a terminal network monitoring system that automates device status control, predicts failures, and reduces operational expenses."
      },
      results: {
        title: "Results",
        items: [
          "Downtime reduced from 6.2% to 0.8%",
          "Maintenance costs decreased by 45%",
          "340% ROI in the first year of implementation",
          "Incident response time reduced from 15 min to 45 sec"
        ]
      },
      tech: {
        title: "Technologies",
        items: ["Node.js", "React", "PostgreSQL", "gRPC", "Protocol Buffers", "Docker"]
      },
      timeline: {
        title: "Project Timeline",
        phases: [
          {
            phase: "Phase 1: Analysis and Design",
            period: "January — March 2025",
            items: ["Existing infrastructure analysis", "TCM architecture design", "Technology stack selection", "Prototype creation"]
          },
          {
            phase: "Phase 2: Core Development",
            period: "April — June 2025",
            items: ["gRPC protocol development", "Monitoring agent creation", "Backend services", "Basic control panel"]
          },
          {
            phase: "Phase 3: Pilot Implementation",
            period: "July — September 2025",
            items: ["Testing on 50 devices", "Metrics and feedback collection", "Performance optimization", "Documentation"]
          },
          {
            phase: "Phase 4: Scaling",
            period: "October 2025 — Present",
            items: ["Expansion to 500+ devices", "AI analytics and forecasting", "SIEM integration", "24/7 support"]
          }
        ]
      },
      cta: {
        title: "Want similar results?",
        subtitle: "Learn how TCM can optimize your terminal infrastructure management",
        button: "Request Demo"
      }
    },
    pilot: {
      title: "Implementation Case",
      subtitle: "Pilot implementation of a monitoring system in a major Russian bank with over 1,000 devices",
      architecture: {
        title: "Solution Architecture",
        cards: [
          { title: "Device Agent", desc: "Node.js + encrypted update service. Works on Windows and Linux." },
          { title: "Server Side", desc: "Express.js, WebSocket, RabbitMQ, PostgreSQL, Redis — fault-tolerant architecture." },
          { title: "Communication Protocol", desc: "Binary protocol based on Protobuf with manual framing and SHA-256/RSA authentication." },
          { title: "Frontend", desc: "React panel for support engineers with real-time monitoring and management." }
        ]
      },
      challenges: {
        title: "Key Challenges and Solutions",
        headers: ["Problem", "Solution"],
        rows: [
          { problem: "Devices behind NAT, no public IPs", solution: "Registration via outgoing WebSocket connection" },
          { problem: "Unstable internet", solution: "Command queue in Redis + auto-retry on recovery" },
          { problem: "Data security", solution: "SHA-256 (RSA) + CRC32 hashing" },
          { problem: "Mass software updates", solution: "Group distribution via RabbitMQ + execution control" }
        ]
      },
      results: {
        title: "Implementation Results",
        headers: ["Metric", "Before", "After", "Effect"],
        rows: [
          { metric: "Response time", before: "15 min", after: "45 sec", effect: "↓ 95%" },
          { metric: "Incidents/month", before: "32", after: "6", effect: "↓ 81%" },
          { metric: "SW update time", before: "2 hours", after: "12 min", effect: "↓ 90%" },
          { metric: "Site visits", before: "8/mo", after: "1/mo", effect: "↓ 88%" },
          { metric: "Terminal downtime", before: "6.2%", after: "0.8%", effect: "↓ 87%" },
          { metric: "Cash gaps", before: "12/mo", after: "1/mo", effect: "↓ 92%" },
          { metric: "OPEX", before: "₽2.4M/mo", after: "₽1.3M/mo", effect: "↓ 46%" }
        ]
      },
      economic: {
        title: "Economic Impact",
        items: [
          { value: "340%", label: "ROI in first year" },
          { value: "5 mo", label: "Payback period" },
          { value: "₽13.2M", label: "Annual savings" }
        ]
      },
      quote: "\"Before, we had to travel to each problem site. Now most incidents are resolved in 2 minutes remotely. This fundamentally changed our work.\"",
      quoteAuthor: "— Support Engineer, Kazan branch",
      cta: "Ready for new projects!\nI participate in pilot implementations of monitoring systems, remote management and IoT infrastructure. Ready to share experience and implement solutions from scratch."
    },
    roadmap: {
      title: "TCM Development Roadmap",
      subtitle: "Strategic development plan for the monitoring system. History of two versions and prospects.",
      heroTitle: "Development Prospects",
      heroSubtitle: "Strategic roadmap for monitoring system development. From basic control to AI analytics and ecosystem.",
      statusPlanned: "Planned",
      
      // Version comparison
      version1: {
        title: "Version 1.0 (2024)",
        badge: "First Version",
        features: [
          "Participated in development at GPB bank",
          "Deployment across 1000+ terminal network devices",
          "Stack: C# (agent), C++ (server)",
          ".NET Framework service",
          "ASN.1 TLV protocol",
          "Basic status and metrics monitoring"
        ]
      },
      version2: {
        title: "Version 2.0 (2025)",
        badge: "Modern",
        features: [
          "Completely redesigned architecture",
          "Single development language — JavaScript (Node.js)",
          "Modern gRPC + Protobuf protocol",
          "High performance and strict typing",
          "Cross-platform agent (Windows + Linux)",
          "React control panel with dark theme",
          "Predictive AI analytics",
          "Cash forecasting"
        ]
      },
      
      phases: [
        {
          period: "2024",
          title: "Version 1.0 — Launch at PSB",
          status: "completed",
          statusLabel: "Completed",
          items: [
            "Development of first version monitoring system",
            "Stack: C#, C++, .NET Framework, ASN.1 TLV",
            "Deployment across 1000+ terminal network devices",
            "Basic monitoring of ATM and terminal status",
            "First results: 40% reduction in downtime"
          ]
        },
        {
          period: "June 2025",
          title: "Graduate Research — RANEPA",
          status: "planned",
          statusLabel: "Planned",
          items: [
            "Enrollment in RANEPA Graduate School",
            "Topic: \"Development of Methods and Algorithms for Financial Message Transmission in the Context of Digital Transformation of Banking Systems\"",
            "Supervisor: Golosov Pavel Yevgenievich, Ph.D. in Technology, Director of ION RANEPA",
            "Scientific novelty: new adaptive coding methods, guaranteed delivery algorithms, channel reliability model",
            "Practical foundation — TCM: implementation of developed methods in the operating system",
            "Publishing results in peer-reviewed journals, dissertation preparation"
          ]
        },
        {
          period: "2025",
          title: "Version 2.0 — Current Version on New Stack",
          status: "completed",
          statusLabel: "Completed",
          items: [
            "Complete architectural redesign of the system",
            "Migration to unified stack — JavaScript (Node.js)",
            "Replaced ASN.1 TLV with gRPC + Protobuf",
            "Created React control panel",
            "Implemented predictive AI analytics",
            "Cross-platform agent for Windows and Linux",
            "ROI 340%, OPEX reduction by 45%"
          ]
        },
        {
          period: "April 2026",
          title: "VTB Accelerator Presentation",
          status: "planned",
          statusLabel: "Planned",
          items: [
            "Project presentation at Sberbank accelerator",
            "Demonstration of implementation results",
            "Investment attraction for scaling",
            "Partnership with major financial institutions"
          ]
        },
        {
          period: "May 2026",
          title: "Top-10 PSB Accelerator",
          status: "planned",
          statusLabel: "Planned",
          items: [
            "Participation in Promsvyazbank accelerator",
            "Entering top-10 best projects of accelerator",
            "Customer base expansion",
            "Readiness for commercial scaling"
          ]
        },
        {
          period: "July 2026",
          title: "Scientific Publication — GUU",
          status: "planned",
          statusLabel: "Planned",
          items: [
            "Publication in journal at GUU scientific and practical conference",
            "Topic: \"Development and Implementation of Distributed Monitoring System for Terminal Infrastructure: gRPC Experience in Financial Sector\"",
            "Migration experience from ASN.1 TLV to gRPC",
            "Practical results for financial sector"
          ]
        },
        {
          period: "October 2026",
          title: "Load Simulator Publication — GitHub",
          status: "planned",
          statusLabel: "Planned",
          items: [
            "Open source release of load testing simulator",
            "Publication on GitHub: github.com/aovakur/Simulator_terminal_monitoring",
            "Open Source license",
            "Ability to test system performance under load",
            "Emulation of multiple terminal device behavior"
          ]
        },
        {
          period: "Q4 2026",
          title: "AI Analytics and Cash Forecasting",
          status: "planned",
          statusLabel: "Planned",
          items: [
            "ML models for cash gap forecasting",
            "Integration with external data sources",
            "Automatic replenishment recommendations",
            "7-30 day cash demand forecast"
          ]
        },
        {
          period: "2027",
          title: "Scaling and Ecosystem",
          status: "planned",
          statusLabel: "Planned",
          items: [
            "Expansion to new device types",
            "Multi-region deployment",
            "Open API for partner integration",
            "Microservices architecture",
            "SaaS model support"
          ]
        }
      ],
      kpi: {
        title: "Key Development Metrics",
        items: [
          { value: "1000+", label: "devices monitored" },
          { value: "340%", label: "ROI in first year" },
          { value: "45%", label: "OPEX reduction" },
          { value: "99.9%", label: "system uptime" }
        ]
      }
    },
    docs: {
      title: "Documentation",
      subtitle: "Data exchange protocol, API and examples of monitoring system interaction",
      proto: "Protobuf",
      swagger: "Swagger API",
      interaction: "Interaction Example",
      swaggerTitle: "Swagger API",
      swaggerDesc: "Complete REST API documentation for the monitoring system. All endpoints for device management, status retrieval and command sending are available.",
      interactionTitle: "Interaction Example",
      interactionDesc: "Guide to testing device connection to TCM server. Describes exchange protocols, commands and interaction examples.",
      quickStart: {
        title: "🚀 Quick Start",
        setup: {
          title: "1. Connection Setup",
          desc: "Specify connection parameters to the server:"
        },
        run: {
          title: "2. Start Testing"
        }
      },
      deviceBehavior: {
        title: "🎯 Device Behavior",
        desc: "When connecting, each device sends a <strong>DeviceEvent</strong> with type <code>CONNECTED</code>:",
        steps: [
          {
            desc: "Sends via <code>SendMessage</code> (stream):",
            items: [
              "<strong>DeviceEvent</strong> — connection event (<code>eventtype: \"CONNECTED\"</code>)",
              "<strong>DeviceStatus</strong> — current device status (devices, os, usb, disks)"
            ]
          },
          {
            desc: "Ready to receive commands from server via <code>SendMessage</code>:",
            items: [
              "<code>GetDeviceStatusRequest</code> → response: <code>DeviceStatus</code>",
              "<code>GetRegistryBranchRequest</code> → response: <code>RegistryBranchResponse</code>",
              "<code>GetRegistryValueRequest</code> → response: <code>RegistryValueResponse</code>",
              "<code>LogRequest</code> → response via <code>GetLog</code> (stream FilePart)",
              "<code>GetDateTime</code> → response: <code>TransportMessage</code>",
              "<code>SetDateTime</code> → set time on device",
              "<code>Restart</code> → restart device",
              "<code>FilePart</code> → receive files from server"
            ]
          },
          {
            desc: "Can send events at any time:",
            items: [
              "<code>DeviceEvent</code> with type <code>DISCONNECTED</code> on disconnect",
              "<code>FilePartAck</code> — file part receipt confirmation",
              "<code>CommandResponse</code> — command execution result"
            ]
          }
        ]
      },
      protocol: {
        title: "📡 Exchange Protocol",
        transport: {
          title: "Transport Level",
          desc: "All messages are transmitted in a <strong>TransportMessage</strong> wrapper:",
          headers: ["Field", "Type", "Description"],
          fields: [
            { field: "uid", type: "string", desc: "128-bit UUID (16 bytes)" },
            { field: "sessionid", type: "string", desc: "Session identifier" },
            { field: "deviceid", type: "string", desc: "Device identifier" },
            { field: "cmdid", type: "uint32", desc: "Task" },
            { field: "timestamp", type: "int64", desc: "Timestamp" },
            { field: "payload", type: "Payload", desc: "Payload (oneof)" },
            { field: "requestid", type: "uint32", desc: "Request ID (for RPC)" },
            { field: "responseto", type: "uint32", desc: "Link to request_id if this is a response" },
            { field: "crc", type: "uint32", desc: "CRC32 of serialized payload" },
            { field: "success", type: "string", desc: "Success result if present" },
            { field: "error", type: "string", desc: "Error result if present" }
          ]
        },
        commands: {
          title: "Payload Commands (oneof)",
          desc: "Payload can contain one of the following commands:",
          headers: ["Message", "Description"],
          items: [
            { msg: "DeviceStatus", desc: "Device status (array)" },
            { msg: "FilePart", desc: "File part transfer" },
            { msg: "LogRequest", desc: "Log file request" },
            { msg: "GetDeviceStatusRequest", desc: "Device status request" },
            { msg: "GetDateTime", desc: "Current time request" },
            { msg: "SetDateTime", desc: "Set time" },
            { msg: "FilePartAck", desc: "File part confirmation" },
            { msg: "GetRegistryRequest", desc: "Full registry request" },
            { msg: "RegistryResponse", desc: "Registry entries response" },
            { msg: "GetRegistryBranchRequest", desc: "Registry branch request" },
            { msg: "RegistryBranchResponse", desc: "Registry branch response" },
            { msg: "GetRegistryValueRequest", desc: "Single value request" },
            { msg: "RegistryValueResponse", desc: "Single value response" },
            { msg: "DeviceEvent", desc: "Connect/disconnect event" },
            { msg: "Restart", desc: "Device restart" },
            { msg: "CommandResponse", desc: "Command response" }
          ]
        },
        examples: [
          { title: "Example: DeviceStatus" },
          { title: "Example: DeviceEvent (device connection)" },
          { title: "Example: LogRequest (log request)" },
          { title: "Example: GetRegistryBranchRequest (registry branch request)" }
        ]
      },
      rpc: {
        title: "🔌 RPC Methods",
        headers: ["Method", "Input", "Output", "Description"],
        methods: [
          { method: "SendMessage", in: "stream TransportMessage", out: "stream TransportMessage", desc: "Bidirectional streaming for all command types" },
          { method: "SendRequest", in: "TransportMessage", out: "TransportMessage", desc: "Single send with response" },
          { method: "DeviceEvent", in: "TransportMessage", out: "stream TransportMessage", desc: "Real-time event subscription" },
          { method: "GetRegistryBranch", in: "GetRegistryBranchRequest", out: "RegistryBranchResponse", desc: "Registry branch request (e.g., \"device/\")" },
          { method: "GetDateTime", in: "GetDateTime", out: "TransportMessage", desc: "Time request from device" },
          { method: "GetDeviceStatus", in: "GetDeviceStatusRequest", out: "DeviceStatus", desc: "Device status with parameters" },
          { method: "SendFilePart", in: "FilePart", out: "FilePartAck", desc: "File part transfer to server" },
          { method: "GetLog", in: "LogRequest", out: "stream FilePart", desc: "Log file request with filtering" }
        ]
      },
      diagrams: {
        title: "📊 Exchange Diagrams",
        connect: { title: "Device Connection (DeviceEvent)" },
        file: { title: "File Transfer (SendFilePart)" },
        log: { title: "Log Request (GetLog)" },
        stream: { title: "Bidirectional Streaming (SendMessage)" },
        stepLabels: {
          connect: "WebSocket connect",
          connected: "Connection established",
          sendOpen: "SendMessage(stream open)",
          sendFilePart1: "SendFilePart",
          filePartAck: "FilePartAck",
          fileCollected: "File assembled from parts",
          getLog: "GetLog",
          streamFilePart: "stream FilePart",
          logReceived: "Log received in parts",
          streamOpen: "Stream open (bidirectional channel)",
          streamClose: "Stream close"
        }
      },
      monitoring: {
        title: "📊 Connection Monitoring",
        desc: "During testing, connection statistics are displayed in real-time:",
        stats: "📊 === CONNECTION STATS ===\n   Total devices: 1000\n   Connected: 998\n   Disconnected: 2\n   Work directory: ./test/devices\n   =========================="
      }
    },
    resources: {
      title: "Documents and Publications",
      subtitle: "Software registration certificate, articles and materials about the TCM project",
      certificate: {
        title: "Software Registration Certificate",
        subtitle: "Official registration of the program for computers with Rospatent",
        download: "Download PDF",
        view: "View",
        sectionTitle: "Software Registration Certificate",
        badge: "✓ Registered",
        name: "TCM — Technical Monitoring System",
        fields: {
          number: "Certificate Number",
          date: "Registration Date",
          type: "Type"
        },
        values: {
          type: "Software"
        },
        description: "Software complex for terminal network monitoring, providing control of ATMs, payment terminals, POS devices and IoT infrastructure in real-time.",
        openReferat: "Open Essay →"
      },
      publication: {
        title: "Scientific Publication",
        badge: "◈ 2026",
        name: "gRPC Experience in the Financial Sector at a Scientific Conference",
        description: "Article on practical experience implementing gRPC and Protocol Buffers for building a high-performance terminal network monitoring system in the financial sector. Issues of security, performance and scalability of the binary data exchange protocol are considered.",
        openArticle: "Open Article →"
      },
      simulator: {
        title: "Load Testing Simulator",
        badge: "○ Open Source",
        name: "Simulator Terminal Monitoring",
        description: "Load testing simulator for the terminal network monitoring system. Allows emulating the behavior of many terminal devices and testing system performance under load.",
        github: "Go to GitHub →"
      },
      articles: {
        title: "Articles on Zen",
        items: [
          {
            badge: "📝 Article",
            name: "gRPC Experience in the Financial Sector",
            desc: "Practical experience implementing gRPC and Protocol Buffers for building a high-performance terminal network monitoring system. Issues of security, performance and scalability.",
            readBtn: "Read on Zen →"
          },
          {
            badge: "📝 Article",
            name: "From Windows to Cross-Platform: How I Rewrote the Monitoring System from Scratch",
            desc: "Migration story from a Windows-only solution to a cross-platform architecture. Refactoring using Node.js, React and modern technologies.",
            readBtn: "Read on Zen →"
          },
          {
            badge: "📝 Article",
            name: "gRPC Experience at a Scientific Conference",
            desc: "Article on practical experience implementing gRPC and Protocol Buffers for building a high-performance terminal network monitoring system in the financial sector. Issues of security, performance and scalability of the binary data exchange protocol are considered.",
            readBtn: "Read on Zen →"
          }
        ]
      },
      cta: "Need detailed information?\nContact us for full technical documentation and implementation discussion."
    },
    referat: {
      title: "Essay — TCM",
      subtitle: "Technical Monitoring System — description, architecture and implementation results",
      introduction: {
        title: "Introduction",
        text: "Modern banks and retail networks manage thousands of terminal devices. Effective monitoring of their status is critically important for ensuring uninterrupted operation and minimizing costs."
      },
      architecture: {
        title: "System Architecture",
        text: "TCM is built on a microservices architecture using gRPC for data exchange between devices and server. The system includes an agent on the device, a server part and a web control panel."
      },
      technology: {
        title: "Technologies",
        text: "Backend: Node.js (Express, Sequelize), PostgreSQL, Redis, RabbitMQ. Frontend: React + Vite. Protocol: gRPC + Protocol Buffers. Agent: cross-platform, works on Windows and Linux."
      },
      results: {
        title: "Results",
        text: "TCM implementation allows reducing maintenance costs by 45%, reducing downtime from 6.2% to 0.8%, increasing ROI to 340% in the first year."
      },
      conclusion: {
        title: "Conclusion",
        text: "TCM demonstrates high efficiency in terminal infrastructure monitoring and can be adapted for various use cases."
      },
      eLibrary: "Publication on eLibrary",
      sectionNames: [
        "Program Name",
        "Program Purpose",
        "Scope of Application",
        "Key Functions",
        "Technical Specifications",
        "Business Benefits",
        "Unique Features",
        "Conclusion"
      ],
      sectionContent: {
        name: "\"TCM — Technical Terminal Network Monitoring System\"",
        purpose: "The program is designed to ensure uninterrupted, safe and efficient operation of ATMs, payment terminals, POS devices and other critically important systems.",
        scope: [
          "Financial sector (banks, payment systems)",
          "Retail trade (POS terminals)",
          "Government institutions and other organizations with distributed terminal infrastructure"
        ],
        functions: [
          "<strong>Real-time device status control:</strong> monitoring online status, CPU usage, memory, temperature, network connection.",
          "<strong>Downtime prevention:</strong> early detection of failures, minimizing response time, reducing financial losses.",
          "<strong>Software management:</strong> centralized updates, remote diagnostics, version control.",
          "<strong>Security:</strong> attack detection, integrity control, blocking compromised devices.",
          "<strong>Analytics and optimization:</strong> collecting usage statistics, generating reports, planning scaling.",
          "<strong>Regulatory compliance:</strong> auditing, event logging, compliance with standards.",
          "<strong>Maintenance simplification:</strong> remote diagnostics, automation of routine operations, maintenance ticket tracking."
        ],
        techArchitecture: [
          "<strong>Backend:</strong> Node.js (Express, Sequelize), PostgreSQL, Redis, RabbitMQ",
          "<strong>Frontend:</strong> React + Vite, Bootstrap",
          "<strong>API:</strong> REST + Swagger, gRPC for device interaction",
          "<strong>Data exchange protocol:</strong> gRPC + Protocol Buffers (Protobuf)",
          "<strong>Monitoring agent:</strong> cross-platform application on Node.js, compatible with Windows and Linux"
        ],
        techDelivery: [
          "<strong>On-Premise (box solution):</strong> deployment in client infrastructure, full data control, integration with internal systems (AD, CRM, SIEM), audit and regulatory support. Suitable for banks and government institutions.",
          "<strong>SaaS (cloud solution):</strong> rapid deployment (within hours), automatic updates, flexible subscription (pay-as-you-go), access from anywhere."
        ],
        techProtocol: {
          advantages: "<strong>Advantages:</strong> high performance, strict typing, streaming support, compact messages, code generation for multiple languages.",
          messages: [
            "<strong>DeviceEvent</strong> — device status change event (connect/disconnect)",
            "<strong>DeviceInfo</strong> — device description (status, model, software version, temperature, battery charge, etc.)",
            "<strong>DeviceStatus</strong> — information about the status of one or more devices",
            "<strong>FilePart / FilePartAck</strong> — file transfer in parts and receipt confirmation",
            "<strong>LogRequest</strong> — log request with filtering by type, time, component and level",
            "<strong>RegistryResponse / RegistryBranchResponse</strong> — responses with device registry parameters",
            "<strong>Restart</strong> — device restart command",
            "<strong>TransportMessage</strong> — main wrapper for all messages (contains UUID, session ID, timestamp, payload, etc.)"
          ],
          services: [
            "<strong>GetDateTime</strong> — request current time from device",
            "<strong>SetDateTime</strong> — set time on device",
            "<strong>GetDeviceStatus</strong> — get device status",
            "<strong>GetRegistry / GetRegistryBranch / GetRegistryValue</strong> — registry parameter requests",
            "<strong>FilePartStream</strong> — bidirectional stream for file transfer",
            "<strong>LogRequest</strong> — log request",
            "<strong>DeviceEventStream</strong> — stream of connect/disconnect events",
            "<strong>RestartDevice</strong> — send restart command"
          ]
        },
        benefits: [
          "Reduced maintenance costs through proactive monitoring",
          "Increased service availability (more working terminals, fewer complaints)",
          "Fast incident response (notifications, automatic scenarios)",
          "Data transparency for analysis and strategic planning",
          "Compliance with security and regulatory requirements"
        ],
        unique: [
          "<strong>Deployment flexibility:</strong> On-Premise and SaaS support",
          "<strong>Cross-platform:</strong> agent works on Windows and Linux",
          "<strong>Data exchange efficiency:</strong> using gRPC and Protobuf for compact and fast data transfer",
          "<strong>Scalability:</strong> architecture allows easy expansion as number of devices grows",
          "<strong>Reliability:</strong> data receipt confirmation mechanisms (CRC32), streaming for large files and logs"
        ],
        conclusion: "\"Technical Terminal Network Monitoring System\" is a modern solution for controlling and managing distributed terminal devices. The combination of high performance (gRPC/Protobuf), deployment flexibility (On-Premise/SaaS) and rich functionality makes the program an optimal choice for organizations requiring uninterrupted operation of critical infrastructure."
      },
      backToDocs: "← Back to Documents"
    },
    demo: {
      title: "Request a Demo",
      subtitle: "Fill out the form and we will contact you to organize a system presentation",
      name: "Name",
      namePlaceholder: "Your name",
      company: "Company",
      companyPlaceholder: "Company name",
      email: "Email",
      emailPlaceholder: "email@company.ru",
      phone: "Phone",
      phonePlaceholder: "+1 (___) ___-__-__",
      devices: "Number of Devices",
      devicesPlaceholder: "Select a range",
      devicesOptions: [
        "Select a range",
        "1 — 100 devices",
        "100 — 500 devices",
        "500 — 1,000 devices",
        "1,000 — 5,000 devices",
        "Over 5,000 devices"
      ],
      message: "Comment",
      messagePlaceholder: "Tell us about your infrastructure and tasks...",
      submit: "Request Demo",
      submitting: "Sending...",
      cancel: "Cancel",
      success: "Thank you! We will contact you shortly.",
      nameError: "Please enter your name",
      companyError: "Please enter company name",
      emailError: "Please enter a valid email",
      phoneError: "Please enter a phone number",
      sendError: "Failed to send request. Please try again later.",
      desc: "Fill out the form and we will show the system in action"
    },
    privacy: {
      title: "Privacy Policy",
      titleEn: "Privacy Policy"
    },
    comingSoon: {
      title: "Coming Soon",
      description: "The application form is temporarily unavailable. We are working on adding this feature. Stay tuned for updates!",
      progress: "Development progress"
    }
  }
}
